import React from "react";
import "./MenuSkeleton.css";

/* Placeholder grid shown while the menu is loading — shaped like the
   real photo-forward product cards (see Product.js/ProductScreen.css)
   so there's no layout jump once data arrives. Reuses .category-section
   from ProductScreen.css (already loaded on this screen) so column
   count/gap always match the real grid exactly. */
function MenuSkeleton({ count = 6 }) {
  return (
    <div className="menu-skeleton" aria-hidden="true">
      <div className="category-section">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton-card">
            <div className="skeleton skeleton-card-media" />
            <div className="skeleton-card-body">
              <div className="skeleton skeleton-line skeleton-line-name" />
              <div className="skeleton skeleton-line skeleton-line-desc" />
              <div className="skeleton skeleton-line skeleton-line-price" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MenuSkeleton;
